import { DoorHistory, MissedAtStopEvent, VehicleAtStopEvent, VehicleHistoryEvent, OffRouteEvent } from './events';

import moment from 'moment';

export class VehicleEvent {
    public data: VehicleHistoryEvent; // depending on eventType the data is different
    public eventType: string;
    public ts: Date;

    public positionTimestamp: Date;

    get tsId() {
        return this.ts ? this.ts.toUTCString() : undefined;
    }

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (obj?.ts) {
            this.ts = moment(obj.ts).toDate();
        }

        // parse different events
        if (obj?.eventType) {
            switch (obj.eventType) {
                case 'DoorEvent':
                    this.data = new DoorHistory(obj.data);
                    this.data.ts = this.ts;
                    break;
                case 'VehicleAtStopEvent':
                    this.data = new VehicleAtStopEvent(obj.data);
                    this.data.ts = this.ts;
                    break;
                case 'ActivityPointMissedEvent':
                    this.data = new MissedAtStopEvent(obj.data);
                    this.data.ts = this.ts;
                    break;
                case 'OffRouteEvent':
                    this.data = new OffRouteEvent(obj.data);
                    this.data.ts = this.ts;
                    break;
                default:
                    break;
            }
        }
    }
}
